import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  useMediaQuery,
  useTheme,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Grid,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Navbar from '../Navbar';
import HomeIcon from "@mui/icons-material/Home";

// Import your resume components
import Resume1, { resumeMeta as resume1Meta } from "./Resume1";
import Resume2, { resumeMeta as resume2Meta } from "./Resume2";
import Resume3, { resumeMeta as resume3Meta } from "./Resume3";
import Resume4, { resumeMeta as resume4Meta } from "./Resume4";
import Resume5, { resumeMeta as resume5Meta } from "./Resume5";
import Resume6, { resumeMeta as resume6Meta } from "./Resume6";
import Resume7, { resumeMeta as resume7Meta } from "./Resume7";
import Resume8, { resumeMeta as resume8Meta } from "./Resume8";
import Resume9, { resumeMeta as resume9Meta } from "./Resume9";
import Resume10, { resumeMeta as resume10Meta } from "./Resume10";
import Resume11, { resumeMeta as resume11Meta } from "./Resume11";
import Resume12, { resumeMeta as resume12Meta } from "./Resume12";
import Resume13, { resumeMeta as resume13Meta } from "./Resume13";
import Resume14, { resumeMeta as resume14Meta } from "./Resume14";
import Resume15, { resumeMeta as resume15Meta } from "./Resume15";
import Resume16, { resumeMeta as resume16Meta } from "./Resume16";
import Resume17, { resumeMeta as resume17Meta } from "./Resume17";
import Resume18, { resumeMeta as resume18Meta } from "./Resume18";
import Resume19, { resumeMeta as resume19Meta } from "./Resume19";
import Resume20, { resumeMeta as resume20Meta } from "./Resume20";
import Resume21, { resumeMeta as resume21Meta } from "./Resume21";
import Resume22, { resumeMeta as resume22Meta } from "./Resume22";
import Resume23, { resumeMeta as resume23Meta } from "./Resume23";
import Resume24, { resumeMeta as resume24Meta } from "./Resume24";
import Resume25, { resumeMeta as resume25Meta } from "./Resume25";
import Resume26, { resumeMeta as resume26Meta } from "./Resume26";
import Resume27, { resumeMeta as resume27Meta } from "./Resume27";
import Resume28, { resumeMeta as resume28Meta } from "./Resume28";
import Resume29, { resumeMeta as resume29Meta } from "./Resume29";
import Resume30, { resumeMeta as resume30Meta } from "./Resume30";
import Resume31, { resumeMeta as resume31Meta } from "./Resume31";
import Resume32, { resumeMeta as resume32Meta } from "./Resume32";
import Resume33, { resumeMeta as resume33Meta } from "./Resume33";
import Resume34, { resumeMeta as resume34Meta } from "./Resume34";
import Resume35, { resumeMeta as resume35Meta } from "./Resume35";
import Resume36, { resumeMeta as resume36Meta } from "./Resume36";
import Resume37, { resumeMeta as resume37Meta } from "./Resume37";
import Resume38, { resumeMeta as resume38Meta } from "./Resume38";
import Resume39, { resumeMeta as resume39Meta } from "./Resume39";
import Resume40, { resumeMeta as resume40Meta } from "./Resume40";
import Resume41, { resumeMeta as resume41Meta } from "./Resume41";
import Resume42, { resumeMeta as resume42Meta } from "./Resume42";
import Resume43, { resumeMeta as resume43Meta } from "./Resume43";
import Resume44, { resumeMeta as resume44Meta } from "./Resume44";
import Resume45, { resumeMeta as resume45Meta } from "./Resume45";
import Resume46, { resumeMeta as resume46Meta } from "./Resume46";
import Resume47, { resumeMeta as resume47Meta } from "./Resume47";
import Resume48, { resumeMeta as resume48Meta } from "./Resume48";
import Resume49, { resumeMeta as resume49Meta } from "./Resume49";
import Resume50, { resumeMeta as resume50Meta } from "./Resume50";

// Color themes for resumes
const resumeThemes = [
  ["#f57c00", "#1a2b47", "#6a1b9a", "#2e7d32", "#d32f2f"],
  ["#bfaeb2", "#1a2b47", "#2e7d32", "#6a1b9a", "#c62828"],
  [
    { bg: "#f5f5f5", primary: "#2c3e50" },
    { bg: "#fff0f0", primary: "#c0392b" },
    { bg: "#f0fff0", primary: "#27ae60" },
    { bg: "#f0f8ff", primary: "#2980b9" },
    { bg: "#fcf3cf", primary: "#f39c12" },
  ],
  [
    { primary: "#b83232", dark: "#5c0606ff" },
    { primary: "#1e88e5", dark: "#0d47a1" },
    { primary: "#43a047", dark: "#1b5e20" },
    { primary: "#fbc02d", dark: "#f57f17" },
    { primary: "#8e24aa", dark: "#4a148c" },
  ],
  ["#1a2b47", "#6a1b9a", "#2e7d32", "#d32f2f", "#f57c00"],
  ["#2196f3", "#4caf50", "#ff5722", "#795548", "#000"],
  [
    { mainBg: "#2e4a23", sideBg: "#3e5a30", highlight: "#b7e1a1", text: "#fff" },
    { mainBg: "#1e3d59", sideBg: "#1a5276", highlight: "#f5b041", text: "#fff" },
    { mainBg: "#4a235a", sideBg: "#512e5f", highlight: "#bb8fce", text: "#fff" },
    { mainBg: "#641e16", sideBg: "#922b21", highlight: "#f1948a", text: "#fff" },
    { mainBg: "#0e6251", sideBg: "#117a65", highlight: "#efb490ff", text: "#fff" },
  ],
  ["#00695c", "#4caf50", "#ff5722", "#795548", "#e61313ff"],
  ["#1976d2", "#2e7d32", "#ed6c02", "#d32f2f", "#7b1fa2"],
  ["#0288d1", "#c2185b", "#388e3c", "#f57c00", "#5d4037"],
  ["#303f9f", "#00796b", "#d84315", "#6a1b9a", "#c62828"],
  ["#5d4037", "#0277bd", "#558b2f", "#e65100", "#6a1b9a"],
  ["#004d40", "#d84315", "#283593", "#689f38", "#ad1457"],
  ["#37474f", "#00838f", "#5d4037", "#2e7d32", "#c62828"],
  ["#4527a0", "#00695c", "#d84315", "#5d4037", "#0277bd"],
  ["#33691e", "#d84315", "#01579b", "#4a148c", "#b71c1c"],
  ["#00695c", "#d84315", "#283593", "#558b2f", "#6a1b9a"],
  ["#004d40", "#d84315", "#1a237e", "#33691e", "#880e4f"],
  ["#1b5e20", "#d84315", "#0d47a1", "#4a148c", "#b71c1c"],
  ["#33691e", "#e65100", "#1565c0", "#6a1b9a", "#c62828"],
  ["#1a237e", "#00695c", "#d84315", "#4a148c", "#b71c1c"],
  ['#2c3e50', "#3f51b5", "#009688", "#ff9800", "#795548"],
  ["#e91e63", "#00bcd4", "#8bc34a", "#ff5722", "#607d8b"],
  ["#673ab7", "#009688", "#ffc107", "#f44336", "#795548"],
  ["#3f51b5", "#4caf50", "#ff9800", "#f44336", "#9c27b0"],
  ["#2196f3", "#ff5722", "#4caf50", "#9c27b0", "#607d8b"],
  ["#4527a0", "#00695c", "#d84315", "#5d4037", "#0277bd"],
  ["#33691e", "#d84315", "#01579b", "#4a148c", "#b71c1c"],
  ["#e91e63", "#00bcd4", "#8bc34a", "#ff5722", "#607d8b"],
  ["#2196f3", "#ff5722", "#4caf50", "#9c27b0", "#607d8b"],
  ["#004d40", "#d84315", "#1a237e", "#33691e", "#880e4f"],
  ["#5d4037", "#0277bd", "#558b2f", "#e65100", "#6a1b9a"],
  ["#37474f", "#00838f", "#5d4037", "#2e7d32", "#c62828"],
  ["#004d40", "#d84315", "#1a237e", "#33691e", "#880e4f"],
  ["#e91e63", "#00bcd4", "#8bc34a", "#ff5722", "#607d8b"],
  ["#0288d1", "#c2185b", "#388e3c", "#f57c00", "#5d4037"],
  ["#004d40", "#d84315", "#1a237e", "#33691e", "#880e4f"],
  ["#e35cc4", "#00695c", "#d84315", "#5d4037", "#0277bd"],
  ["#5d4037", "#0277bd", "#558b2f", "#e65100", "#6a1b9a"],
  ["#e5b675", "#009688", "#e8bbde", "#777171", "#795548"],
  ["#e35cc4", "#00695c", "#d84315", "#5d4037", "#0277bd"],
  ["#4527a0", "#00695c", "#d84315", "#5d4037", "#0277bd"],
  ["#004d40", "#d84315", "#1a237e", "#33691e", "#880e4f"],
  ["#00695c", "#4caf50", "#ff5722", "#795548", "#e61313ff"],
  ["#e91e63", "#00bcd4", "#8bc34a", "#ff5722", "#607d8b"],
  ["#00695c", "#d84315", "#283593", "#558b2f", "#6a1b9a"],
  ["#e35cc4", "#00695c", "#d84315", "#5d4037", "#0277bd"],
  ["#4527a0", "#00695c", "#d84315", "#5d4037", "#0277bd"],
  ["#e91e63", "#00bcd4", "#8bc34a", "#ff5722", "#607d8b"],
  ["#303f9f", "#00796b", "#d84315", "#6a1b9a", "#c62828"],
  ["#2196f3", "#ff5722", "#4caf50", "#9c27b0", "#607d8b"],
];

const resumes = [
  Resume1, Resume2, Resume3, Resume4,
  Resume5, Resume6, Resume7, Resume8,
  Resume9, Resume10, Resume11, Resume12,
  Resume13, Resume14, Resume15, Resume16,
  Resume17, Resume18, Resume19, Resume20,
  Resume21, Resume22, Resume23, Resume24,
  Resume25, Resume26, Resume27, Resume28, Resume29,
  Resume30, Resume31, Resume32, Resume33, Resume34, Resume35,
  Resume36, Resume37, Resume38, Resume39, Resume40, Resume41, Resume42, Resume43, Resume44, Resume45,
  Resume46, Resume47, Resume48, Resume49, Resume50,
];

const resumeMetas = [
  resume1Meta, resume2Meta, resume3Meta, resume4Meta,
  resume5Meta, resume6Meta, resume7Meta, resume8Meta,
  resume9Meta, resume10Meta, resume11Meta, resume12Meta,
  resume13Meta, resume14Meta, resume15Meta, resume16Meta,
  resume17Meta, resume18Meta, resume19Meta, resume20Meta,
  resume21Meta, resume22Meta, resume23Meta, resume24Meta,
  resume25Meta, resume26Meta, resume27Meta, resume28Meta,
  resume29Meta, resume30Meta, resume31Meta, resume32Meta,
  resume33Meta, resume34Meta, resume35Meta, resume36Meta,
  resume37Meta, resume38Meta, resume39Meta, resume40Meta, resume41Meta, resume42Meta, resume43Meta, resume44Meta, resume45Meta,
  resume46Meta, resume47Meta, resume48Meta, resume49Meta, resume50Meta,
];

const ResumeList = ({ experience }) => {
  const [selectedThemes, setSelectedThemes] = useState(
    resumeThemes.map((palette) => palette[0])
  );
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [filtersOpen, setFiltersOpen] = useState(false);
  
  // Filter state
  const [filters, setFilters] = useState({
    withPhoto: false,
    withoutPhoto: false,
    oneColumn: false,
    twoColumn: false,
  });

  const handleThemeChange = (resumeIdx, colorOrObj) => {
    setSelectedThemes((prev) =>
      prev.map((theme, idx) => (idx === resumeIdx ? colorOrObj : theme))
    );
  };

  const handleFilterChange = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.checked });
  };

  const handleTemplateSelect = (templateIndex, theme) => {
    const token = localStorage.getItem("token");

    if (token) {
      navigate("/HeadingContactPage", {
        state: {
          selectedTemplate: templateIndex + 1,
          selectedTheme: theme,
        },
      });
    } else {
      localStorage.setItem("pendingTemplate", JSON.stringify({
        selectedTemplate: templateIndex + 1,
        selectedTheme: theme,
      }));
      navigate("/Signup");
    }
  };

  // Get recommended templates based on experience
  const getRecommendedIndexes = (exp) => {
    if (!exp || exp === "3-5 Years") {
      return [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,27,28,29,30,31,32,33,34,36,42,45,48,50];
    }
    if (exp === "No Experience") {
      return [2,5,6,11,13,14,15,16,17,20,21,23,26,27,28,29,31,33,40,41,47];
    }
    if (exp === "Less than 3 years") {
      return [1,2,4,5,8,9,13,14,15,16,17,18,19,20,21,22,23,25,26,27,28,29,31,32,33,34,35,38,43,44,46,50];
    }
    if (exp === "5-10 Years") {
      return [0,3,4,7,9,10,11,12,14,18,19,20,21,22,23,24,25,30,31,32,35,36,37,38,39];
    }
    if (exp === "10+ Years") {
      return [0,3,6,7,10,12,19,21,22,23,24,25,29,30,36,37,38,39];
    }
    return [1,2,3,8,9,10];
  };

  const recommendedIndexes = getRecommendedIndexes(experience);

  // Filter templates based on selected filters
  const filteredIndexes = resumes
    .map((_, idx) => idx)
    .filter((idx) => {
      const meta = resumeMetas[idx];

      // PHOTO FILTER
      if (filters.withPhoto && filters.withoutPhoto) {
        // both selected → show all
      } else if (filters.withPhoto && !meta.hasPhoto) {
        return false;
      } else if (filters.withoutPhoto && meta.hasPhoto) {
        return false;
      }

      // COLUMN FILTER
      if (filters.oneColumn && filters.twoColumn) {
        // both selected → show all
      } else if (filters.oneColumn && meta.columns !== 1) {
        return false;
      } else if (filters.twoColumn && meta.columns !== 2) {
        return false;
      }

      // EXPERIENCE FILTER
      if (experience) {
        const recommended = getRecommendedIndexes(experience);
        return recommended.includes(idx);
      }

      return true;
    });

  // ─── helper: get the display color string for a theme value ───────────────
  const getDisplayColor = (colorOrObj) => {
    if (typeof colorOrObj === "string") return colorOrObj;
    return (
      colorOrObj?.primary ||
      colorOrObj?.highlight ||
      colorOrObj?.mainBg ||
      "#ccc"
    );
  };

// ─── helper: check if a theme is currently selected ───────────────────────
const isSelected = (current, candidate) => {
  // Both are strings - exact match
  if (typeof current === "string" && typeof candidate === "string") {
    return current === candidate;
  }
  
  // Both are objects - compare all keys
  if (typeof current === "object" && typeof candidate === "object") {
    const currentKeys = Object.keys(current);
    const candidateKeys = Object.keys(candidate);
    
    // Different number of keys → not equal
    if (currentKeys.length !== candidateKeys.length) {
      return false;
    }
    
    // Check if ALL keys match
    for (let key of currentKeys) {
      if (current[key] !== candidate[key]) {
        return false;
      }
    }
    return true;
  }
  
  // One is string, other is object → not equal
  return false;
};

  // Resume card rendering function
  const renderResumeCard = (index) => {
    const ResumeComponent = resumes[index];
    const cardWidth = isMobile ? 280 : 300;
    const cardHeight = isMobile ? 380 : 420;
    const scaleFactor = isMobile ? 380 / 1123 : 420 / 1123;
    
    return (
      
      <Box key={index} display="flex" flexDirection="column" alignItems="center" sx={{ width: isMobile ? "100%" : "auto", mb: 4 }}>
        
        <Card
          sx={{
            width: cardWidth,
            height: cardHeight,
            position: "relative",
            border: "1px solid #ddd",
            boxShadow: 3,
            overflow: "hidden",
            transition: "all 0.3s ease",
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: 6,
            }
          }}
        >
          <CardContent
            sx={{
              p: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              bgcolor: "#eee",
              position: "relative",
            }}
          >
            <Box
              sx={{
                width: "210mm",
                height: "297mm",
                transform: `scale(${scaleFactor})`,
                transformOrigin: "center",
              }}
            >
              <ResumeComponent
                color={selectedThemes[index]}
                theme={selectedThemes[index]}
                setTheme={(colorOrObj) => handleThemeChange(index, colorOrObj)}
              />
            </Box>
          </CardContent>

          {recommendedIndexes.includes(index) && (
            <Chip
              label="RECOMMENDED"
              color="secondary"
              size="small"
              sx={{
                position: "absolute",
                bottom: 8,
                right: 8,
                fontWeight: "bold",
                fontSize: "0.7rem",
              }}
            />
          )}
        </Card>

        {/* ── CHANGED: Color picker section with label ── */}
        <Box
          sx={{
            mt: 2,
            width: cardWidth,
            bgcolor: "#f8f9fa",
            borderRadius: 2,
            border: "1px solid #e9ecef",
            px: 1.5,
            py: 1,
          }}
        >
          {/* Label */}
          <Typography
            variant="caption"
            sx={{
              display: "block",
              textAlign: "center",
              color: "#888",
              fontSize: "0.7rem",
              letterSpacing: "0.05em",
              mb: 1,
              textTransform: "uppercase",
              fontWeight: 600,
            }}
          >
            🎨 Choose a color
          </Typography>

          {/* Color dots */}
          <Box display="flex" justifyContent="center" gap={1.2} flexWrap="wrap">
            {resumeThemes[index].map((colorOrObj, i) => {
              const displayColor = getDisplayColor(colorOrObj);
              const selected = isSelected(selectedThemes[index], colorOrObj);
              return (
                <Box
                  key={i}
                  onClick={() => handleThemeChange(index, colorOrObj)}
                  title={displayColor}
                  sx={{
                    position: "relative",
                    width: selected ? 30 : 26,
                    height: selected ? 30 : 26,
                    borderRadius: "50%",
                    bgcolor: displayColor,
                    cursor: "pointer",
                    // Thick white ring + colored shadow when selected
                    border: selected
                      ? `3px solid #fff`
                      : "2.5px solid #fff",
                    boxShadow: selected
                      ? `0 0 0 2.5px ${displayColor}, 0 4px 10px ${displayColor}66`
                      : "0 2px 6px rgba(0,0,0,0.22)",
                    transition: "all 0.2s ease",
                    '&:hover': {
                      transform: 'scale(1.25)',
                      boxShadow: `0 0 0 2px ${displayColor}, 0 4px 12px ${displayColor}88`,
                    },
                  }}
                >
                  {/* Checkmark on selected dot */}
                  {selected && (
                    <Box
                      sx={{
                        position: "absolute",
                        inset: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: "0.7rem",
                        fontWeight: 900,
                        textShadow: "0 1px 2px rgba(0,0,0,0.5)",
                        lineHeight: 1,
                      }}
                    >
                      ✓
                    </Box>
                  )}
                </Box>
              );
            })}
          </Box>
        </Box>
        {/* ── END CHANGED ── */}

        <Button
          variant="contained"
          sx={{
            background: "linear-gradient(45deg, #2196f3 30%, #21cbf3 90%)",
            color: "#fff",
            fontWeight: "bold",
            px: 3,
            py: 1.5,
            borderRadius: "25px",
            width: "100%",
            mt: 2,
            maxWidth: cardWidth,
            fontSize: "0.9rem",
            "&:hover": {
              background: "linear-gradient(45deg, #1976d2 30%, #21cbf3 90%)",
              transform: 'translateY(-2px)',
              boxShadow: 4,
            },
            transition: 'all 0.3s ease',
          }}
          onClick={() => handleTemplateSelect(index, selectedThemes[index])}
        >
          Choose Template
        </Button>
      </Box>
    );
  };

  const renderFilters = () => (
    <Box
      sx={{
        p: 2,
        border: "1px solid #ddd",
        borderRadius: 2,
        bgcolor: "#fafafa",
        position: "sticky",
        top: 20,
      }}
    >
      <Typography variant="h6" gutterBottom>
        Filters
      </Typography>
      <Typography variant="subtitle2" sx={{ mt: 2 }}>
        Headshot
      </Typography>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.withPhoto}
              onChange={handleFilterChange}
              name="withPhoto"
            />
          }
          label="With Photo"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.withoutPhoto}
              onChange={handleFilterChange}
              name="withoutPhoto"
            />
          }
          label="Without Photo"
        />
      </FormGroup>

      <Typography variant="subtitle2" sx={{ mt: 2 }}>
        Columns
      </Typography>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.oneColumn}
              onChange={handleFilterChange}
              name="oneColumn"
            />
          }
          label="1 Column"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.twoColumn}
              onChange={handleFilterChange}
              name="twoColumn"
            />
          }
          label="2 Column"
        />
      </FormGroup>
    </Box>
  );

  return (
     <>
    <Navbar />
    <Container maxWidth="xl" sx={{ mt: 5, px: isMobile ? 2 : 3, mb: 8 }}>
      {/* Back Button and Go to Home Button */}
<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
  <Button
    startIcon={<ArrowBackIcon />}
    onClick={() => navigate("/experience-level")}
    sx={{
      fontWeight: "bold",
      color: "#333",
      textTransform: "none",
    }}
  >
    Back
  </Button>

  <Button
    startIcon={<HomeIcon />}
    onClick={() => navigate("/")}
    sx={{
      fontWeight: "bold",
      color: "#333",
      textTransform: "none",
    }}
  >
    Go to Home
  </Button>
</Box>

      <Typography variant="h4" fontWeight="bold" textAlign="center" sx={{ fontSize: isMobile ? "1.8rem" : "2.125rem" }}>
        Best Templates for {experience ? experience : "Your Experience"}
      </Typography>
      <Typography
        variant="subtitle1"
        color="text.secondary"
        textAlign="center"
        sx={{ mb: 4, fontSize: isMobile ? "0.9rem" : "1rem" }}
      >
        Choose your perfect resume template and build your professional resume in minutes
      </Typography>

      {isMobile ? (
        <>
          <Box display="flex" justifyContent="center" mb={2}>
            <Button
              variant="outlined"
              startIcon={<FilterListIcon />}
              onClick={() => setFiltersOpen(!filtersOpen)}
              sx={{ mb: 2 }}
            >
              {filtersOpen ? "Hide Filters" : "Show Filters"}
            </Button>
          </Box>
          
          {filtersOpen && (
            <Box sx={{ mb: 3 }}>
              {renderFilters()}
            </Box>
          )}
          
          <Box 
            display="grid" 
            gridTemplateColumns="repeat(auto-fill, minmax(280px, 1fr))" 
            gap={3}
            justifyContent="center"
          >
            {filteredIndexes.map((index) => renderResumeCard(index))}
          </Box>
        </>
      ) : (
        <Box display="flex" gap={4}>
          {/* LEFT FILTERS */}
          <Box sx={{ width: "280px", flexShrink: 0 }}>
            {renderFilters()}
          </Box>

          {/* RIGHT RESUMES */}
          <Box sx={{ flex: 1 }}>
            <Box 
              display="grid" 
              gridTemplateColumns="repeat(auto-fill, minmax(300px, 1fr))" 
              gap={4}
            >
              {filteredIndexes.map((index) => renderResumeCard(index))}
            </Box>
          </Box>
        </Box>
      )}

      {/* Footer Info */}
      <Box sx={{ mt: 6, textAlign: 'center', p: 4, bgcolor: '#f8f9fa', borderRadius: 3 }}>
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 2 }}>
          "Create a standout resume in minutes. Your dream job awaits!"
        </Typography>
        
        <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
          All templates are completely free • No ads required • Start building your professional resume today
        </Typography>
      </Box>
    </Container>
    </>
  );
};

export default ResumeList;